/**
 * Prediction contest (Google Form) — timezone-aware countdown.
 */
(function () {
  'use strict';

  function parseConfig(root) {
    var el = root.querySelector('[data-prediction-contest-config]');
    if (!el) {
      return null;
    }
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function parseEndInTimeZone(dateStr, timeStr, timeZone) {
    var parts = (dateStr || '').trim().split('-');
    var timeParts = (timeStr || '23:59').trim().split(':');
    if (parts.length < 3) {
      return NaN;
    }
    var y = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10);
    var d = parseInt(parts[2], 10);
    var hh = parseInt(timeParts[0], 10) || 0;
    var mm = parseInt(timeParts[1], 10) || 0;
    var tz = timeZone || 'UTC';
    var utc = Date.UTC(y, m - 1, d, hh, mm, 0);
    var i;
    for (i = 0; i < 4; i += 1) {
      var dtf = new Intl.DateTimeFormat('en-US', {
        timeZone: tz,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      });
      var map = {};
      dtf.formatToParts(new Date(utc)).forEach(function (p) {
        if (p.type !== 'literal') {
          map[p.type] = p.value;
        }
      });
      var asUtc = Date.UTC(
        parseInt(map.year, 10),
        parseInt(map.month, 10) - 1,
        parseInt(map.day, 10),
        parseInt(map.hour, 10),
        parseInt(map.minute, 10),
        parseInt(map.second, 10) || 0
      );
      var target = Date.UTC(y, m - 1, d, hh, mm, 0);
      utc += target - asUtc;
    }
    return utc;
  }

  function formatCountdown(ms) {
    if (ms <= 0) {
      return null;
    }
    var s = Math.floor(ms / 1000);
    var days = Math.floor(s / 86400);
    s -= days * 86400;
    var hours = Math.floor(s / 3600);
    s -= hours * 3600;
    var minutes = Math.floor(s / 60);
    s -= minutes * 60;
    var bits = [];
    if (days > 0) {
      bits.push(days + 'd');
    }
    bits.push(String(hours).padStart(2, '0') + 'h');
    bits.push(String(minutes).padStart(2, '0') + 'm');
    bits.push(String(s).padStart(2, '0') + 's');
    return bits.join(' ');
  }

  function applyClosedState(root, cfg) {
    var embedWrap = root.querySelector('[data-pc-embed-wrap]');
    var closed = root.querySelector('[data-pc-closed]');
    var actions = root.querySelector('[data-pc-actions]');
    if (!cfg.hideFormWhenClosed) {
      if (closed) {
        closed.hidden = false;
      }
      return;
    }
    if (embedWrap) {
      embedWrap.hidden = true;
    }
    if (actions) {
      actions.hidden = true;
    }
    if (closed) {
      closed.hidden = false;
    }
  }

  function initCountdown(root, cfg) {
    var box = root.querySelector('[data-pc-countdown]');
    if (!box || !cfg.endDate) {
      return NaN;
    }
    var endMs = parseEndInTimeZone(cfg.endDate, cfg.endTime, cfg.timezone);
    var timerEl = box.querySelector('[data-pc-countdown-timer]');
    var endedLabel = cfg.endedLabel || 'Entries closed';
    var liveLabel = cfg.countdownLabel || 'Closes in';
    var timerId;

    function tick() {
      if (!isFinite(endMs) || isNaN(endMs)) {
        return;
      }
      var left = endMs - Date.now();
      if (left <= 0) {
        box.classList.add('is-ended');
        if (timerEl) {
          timerEl.textContent = endedLabel;
        }
        applyClosedState(root, cfg);
        return;
      }
      if (timerEl) {
        timerEl.textContent = formatCountdown(left);
      }
      timerId = window.setTimeout(tick, 1000);
    }

    if (timerEl) {
      timerEl.textContent = '…';
    }
    tick();

    root.addEventListener(
      'shopify:section:unload',
      function () {
        if (timerId) {
          window.clearTimeout(timerId);
        }
      },
      { once: true }
    );

    return endMs;
  }

  function initSection(root) {
    var cfg = parseConfig(root);
    if (!cfg) {
      return;
    }
    var endMs = initCountdown(root, cfg);
    if (isFinite(endMs) && endMs > 0 && Date.now() >= endMs) {
      var box = root.querySelector('[data-pc-countdown]');
      if (box) {
        box.classList.add('is-ended');
        var timerEl = box.querySelector('[data-pc-countdown-timer]');
        if (timerEl) {
          timerEl.textContent = cfg.endedLabel || 'Entries closed';
        }
      }
      applyClosedState(root, cfg);
    }
  }

  function boot() {
    document.querySelectorAll('[data-prediction-contest]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target) {
      return;
    }
    var root =
      target.querySelector('[data-prediction-contest]') ||
      (target.matches && target.matches('[data-prediction-contest]') ? target : null);
    if (root) {
      initSection(root);
    }
  });
})();
